import React from "react";
import * as styles from "./style.module.scss";
import Radio from "@mui/material/Radio";
import Tooltip from "@mui/material/Tooltip";
import { useTheme } from "@mui/material/styles";
import RemoveRedEyeOutlined from "@mui/icons-material/RemoveRedEyeOutlined";

const NotificationStatusTrigger = ({
  isFollowing,
  title,
  notification,
  handleClick,
}) => {
  const {
    palette: { base },
  } = useTheme();

  return (
    <Tooltip placement="left" title={title} arrow>
      {isFollowing ? (
        <RemoveRedEyeOutlined
          style={{
            cursor: "pointer",
            marginRight: "10px",
          }}
          onClick={() => handleClick(notification?.id)}
        />
      ) : (
        <span
          style={{
            width: 10,
            height: 10,
            borderRadius: "100%",
            backgroundColor: "var(--palette-secondary_button_text)",
            cursor: "pointer",
            marginRight: "10px",
          }}
          onClick={() => handleClick(notification?.id)}
        />
      )}
    </Tooltip>
  );
};

export default NotificationStatusTrigger;
